// Tier-2 <Steps> backed by AntD Steps (FORT-331). Steps are passed as data
// (items). `current` marks the active step; colours come from the token-sourced
// theme, so no useTokens() here.
import React from 'react';
import { Steps as AntSteps } from 'antd';
import type { CommonProps } from './types';

export type StepStatus = 'wait' | 'process' | 'finish' | 'error';

export interface StepItem {
  title: React.ReactNode;
  description?: React.ReactNode;
  status?: StepStatus;
  icon?: React.ReactNode;
}

export interface StepsProps extends CommonProps {
  items: StepItem[];
  /** Zero-based index of the active step. */
  current?: number;
  direction?: 'horizontal' | 'vertical';
  size?: 'default' | 'small';
  /** Status of the current step (drives its colour). */
  status?: StepStatus;
}

export const Steps: React.FC<StepsProps> = ({
  items,
  current = 0,
  direction = 'horizontal',
  size = 'default',
  status = 'process',
  className,
  style,
  'data-testid': dataTestId,
}) => (
  <AntSteps
    items={items}
    current={current}
    direction={direction}
    size={size}
    status={status}
    className={className}
    style={style}
    data-testid={dataTestId}
  />
);
